import { render, staticRenderFns } from "./BldArt.vue?vue&type=template&id=4e825da2&scoped=true&"
import script from "./BldArt.vue?vue&type=script&lang=js&"
export * from "./BldArt.vue?vue&type=script&lang=js&"
import style0 from "./BldArt.vue?vue&type=style&index=0&id=4e825da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e825da2",
  null
  
)

export default component.exports